<template>
    <div class="fair-view__contents">
        <div v-html="fair.content[$i18n.locale]">
        </div>
    </div>
</template>

<script>
export default {
    props: ["fair"],
};
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
</style>